import { createSlice } from "@reduxjs/toolkit";

export const supportTicketFormSlice = createSlice({
    name: 'supportTicketForm',
    initialState: {
        supportTicketId: '',
        ticketType: 'Bug',
        supportLevel: '1',
        title: '',
        ticketContents: '',
        severity: '1. Blocker',
        status: '',
        formActive: false,
        formMode: '',
        formMessage: '',
        confirmEscalation: false
    },
    reducers: {
        prefillSupportTicketForm: (state, action) => {
            return {
                ...state,
                supportTicketId: action.payload.supportTicketId,
                ticketType: action.payload.ticketType,
                supportLevel: action.payload.supportLevel,
                title: action.payload.title,
                ticketContents: action.payload.ticketContents,
                severity: action.payload.severity,
                status: action.payload.status
            }
        },
        changeSupportTicketId: (state, action) => {
            return {
                ...state,
                supportTicketId: action.payload
            }
        },
        changeTicketType: (state, action) => {
            return {
                ...state,
                ticketType: action.payload
            }
        },
        changeSupportLevel: (state, action) => {
            return {
                ...state,
                supportLevel: action.payload
            }
        },
        changeTitle: (state, action) => {
            return {
                ...state,
                title: action.payload
            }
        },
        changeTicketContents: (state, action) => {
            return {
                ...state,
                ticketContents: action.payload
            }
        },
        changeSeverity: (state, action) => {
            return {
                ...state,
                severity: action.payload
            }
        },
        changeStatus: (state, action) => {
            return {
                ...state,
                status: action.payload
            }
        },
        changeFormActive: (state, action) => {
            return {
                ...state,
                formActive: action.payload
            }
        },
        changeFormMode: (state, action) => {
            return {
                ...state,
                formMode: action.payload
            }
        },
        changeFormMessage: (state, action) => {
            return {
                ...state,
                formMessage: action.payload
            }
        },
        changeConfirmEscalation: (state, action) => {
            return {
                ...state,
                confirmEscalation: action.payload
            }
        },
        clearSupportTicketForm: (state) => {
            return {
                ...state,
                supportTicketId: '',
                ticketType: '',
                title: '',
                ticketContents: '',
                severity: '',
                status: '',
                formActive: false
            }
        }
    }
})

export const selectSupportTicketId = (state) => state.supportTicketForm.supportTicketId;
export const selectTicketType = (state) => state.supportTicketForm.ticketType;
export const selectSupportLevel = (state) => state.supportTicketForm.supportLevel;
export const selectTitle = (state) => state.supportTicketForm.title;
export const selectTicketContents = (state) => state.supportTicketForm.ticketContents;
export const selectSeverity = (state) => state.supportTicketForm.severity;
export const selectStatus = (state) => state.supportTicketForm.status;
export const isFormActive = (state) => state.supportTicketForm.formActive;
export const selectFormMode = (state) => state.supportTicketForm.formMode;
export const selectFormMessage = (state) => state.supportTicketForm.formMessage;
export const confirmingEscalation = (state) => state.supportTicketForm.confirmEscalation;

export const { 
    changeSupportTicketId, 
    changeTicketType,
    changeSupportLevel, 
    changeTitle, 
    changeTicketContents, 
    changeSeverity, 
    changeStatus, 
    changeFormActive, 
    clearSupportTicketForm,
    changeFormMode,
    changeFormMessage,
    changeConfirmEscalation,
    prefillSupportTicketForm
} = supportTicketFormSlice.actions;

export default supportTicketFormSlice.reducer;